<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-menu #menuContextuelItemVente popup="popup" [model]="menuContextuel"></p-menu>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div class="grid" *ngIf="EstCharge()">
    <div class="col-12">
        <p-card styleClass="my-2">
            <div class="flex align-content-center justify-content-between mb-2">
                <div class="flex align-items-center gap-2 flex-wrap">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input #rechercheVente pInputText type="text" [(ngModel)]="globalFilter"
                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                            placeholder="Recherche..." />
                    </span>
                    <button *ngIf="estAutorise('ventes_creer')" pButton pRipple icon="pi pi-plus"
                        class="p-button-success" label="Ajouter" (click)="AjouterVente()"></button>
                    <button pButton pRipple icon="pi pi-filter-slash" class="p-button-outlined"
                        pTooltip="Réinitialiser les filtres" tooltipPosition="bottom" (click)="clearFilters(dt)"></button>
                </div>
                <div>
                    <p-multiSelect [options]="colonnesDisponibles" [(ngModel)]="selectedColumns"
                        optionLabel="entete" selectedItemsLabel="{0} colonnes sélectionnés"
                        [style]="{minWidth: '200px'}" placeholder="Colonnes..."></p-multiSelect>
                </div>
            </div>
            <p-table #dt [value]="ventes" [columns]="selectedColumns" dataKey="venteId" 
                autoLayout="true" sortMode="multiple" [multiSortMeta]="sortMeta" tableStyleClass="tableNormale" [rowHover]="true"
                [rows]="25" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]" [first]="tableParams.getValue().first ?? 0" [rows]="tableParams.getValue().rows ?? 25"
                [globalFilterFields]="['numero','description','client.nom','employe.prenomNom','creePar.prenomNom']"
                [lazy]="true" [totalRecords]="totalRecords" [loading]="!chargementVentesComplete || !ventes" (onLazyLoad)="onLazyLoad($event)">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="numero">
                            <div class="flex justify-content-between align-items-center">
                                Numéro
                                <p-sortIcon field="numero"></p-sortIcon>
                                <p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="description">
                            <div class="flex justify-content-between align-items-center">
                                Description
                                <p-sortIcon field="description"></p-sortIcon>
                                <p-columnFilter type="text" field="description" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="client">
                            <div class="flex justify-content-between align-items-center">
                                Client
                                <p-sortIcon field="client.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="client" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="statut.statutId">
                            <div class="flex justify-content-between align-items-center">
                                Statut
                                <p-sortIcon field="statut.statutId"></p-sortIcon>
                                <p-columnFilter field="statut.statutId" matchMode="in" display="menu" [showMatchModes]="false"
                                    [showOperator]="false" [showAddButton]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
                                            (onChange)="filter($event.value)" optionLabel="nom" optionValue="statutId">
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('employe')" pSortableColumn="employe.prenomNom">
                            <div class="flex justify-content-between align-items-center">
                                Employé responsable
                                <p-sortIcon field="employe.prenomNom"></p-sortIcon>
                                <p-columnFilter type="text" field="employe.prenomNom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateLivraison')" pSortableColumn="dateLivraison">
                            <div class="flex justify-content-between align-items-center">
                                Date de livraison
                                <p-sortIcon field="dateLivraison"></p-sortIcon>
                                <p-columnFilter type="date" field="dateLivraison" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateCreation')" pSortableColumn="dateCreation">
                            <div class="flex justify-content-between align-items-center">
                                Date de création
                                <p-sortIcon field="dateCreation"></p-sortIcon>
                                <p-columnFilter type="date" field="dateCreation" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('creePar')" pSortableColumn="creePar.prenomNom">
                            <div class="flex justify-content-between align-items-center">
                                Créé par
                                <p-sortIcon field="creePar.prenomNom"></p-sortIcon>
                                <p-columnFilter type="text" field="creePar.prenomNom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th style="min-width: 10rem;"></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-vente let-columns="columns">
                    <tr>
                        <td>
                            <a *ngIf="estAutorise('ventes_consulter')"
                                [routerLink]="'/vente/' + vente.venteId">{{vente.numero}}</a>
                            <span *ngIf="!estAutorise('ventes_consulter')">{{vente.numero}}</span>
                        </td>
                        <td>{{vente.description}}</td>
                        <td>{{vente.client}}</td>
                        <td>
                            <span [class]="'statut ' + vente.statut?.nom?.toLowerCase().replace(' ', '')">
                                {{vente.statut?.nom}}
                            </span>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('employe')"><app-employe-avec-emplacement [employe]="vente.employe"></app-employe-avec-emplacement></td>
                        <td *ngIf="EstColonneSelectionnee('dateLivraison')">{{vente.dateLivraison | date:'yyyy-MM-dd'}}</td>
                        <td *ngIf="EstColonneSelectionnee('dateCreation')">{{vente.dateCreation | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                        <td *ngIf="EstColonneSelectionnee('creePar')"><app-employe-avec-emplacement [employe]="vente.creePar"></app-employe-avec-emplacement></td>
                        <td class="celluleTableau">
                            <div class="flex">
                                <button *ngIf="estAutorise('ventes_consulter')" pButton pRipple icon="pi pi-eye"
                                    class="p-button-success mr-2 boutonGrille"
                                    (click)="OuvrirDetailVente(vente.venteId)"></button>
                                <button *ngIf="estAutorise('ventes_consulter')" pButton pRipple icon="pi pi-external-link"
                                    class="p-button-secondary mr-2 boutonGrille"
                                    (click)="OuvrirDetailVenteNouvelOnglet(vente.venteId)"></button>
                                <button *ngIf="estAutorise('ventes_modifier')" pButton pRipple icon="pi pi-trash" class="p-button-danger mr-2 boutonGrille"
                                    (click)="SupprimerVente(vente)"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="12" class="text-center">
                            <div class="flex flex-column p-4 justify-content-center align-items-center">
                                <i class="pi pi-search text-2xl mb-2"></i>
                                <span class="text-900">Aucune vente trouvée.</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>
</div>

<p-sidebar [(visible)]="afficherDetailVente" [style]="{width:'95%'}" position="left">
    <app-detail-vente [venteId]="detailVenteId" *ngIf="afficherDetailVente"></app-detail-vente>
</p-sidebar>
